<template>
    <b-modal modal-class="red-alert" ref="deletemodal" centered :lazy="true" title="Are You Sure?" :hide-header-close="true" no-fade>
        <div class="prompt-text">
            Are you sure you want to delete?
        </div>

        <div slot="modal-footer" class="w-100">
            <div class="float-right">
                <b-btn variant="flat" @click="no">
                    No! Don't
                </b-btn>
                <b-btn variant="danger" @click="yes">
                    &nbsp;&nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
import _ from "lodash";
export default {
  name: "deletemodal",
  data() {
    return {};
  },
  methods: {
    yes() {
      this.$emit("yes");
    },
    no() {
      this.$refs.deletemodal.hide();
      this.$emit("no");
    }
  }
};
</script>

<style scoped>
.prompt-text{
  padding: 32px 44px 44px 44px;
}
</style>
